
















import { format } from 'date-fns'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import Inquiry from '../../../api/v2/models/inquiry'

@Component({})
export default class InquiryView extends Vue {
  @Prop({
    required: true
  })
  inquiry: Inquiry

  dateFormat(date: Date) {
    return format(date, 'YYYY/MM/DD HH:mm')
  }
}
